<template>
    <div>
        <v-list>
            <v-list-tile avatar>
                <!-- Icono -->
                <v-list-tile-action>
                    <v-icon :color="'#' + baseGrid.colorFondo" @click="irABase(baseGrid.id)" class="pointer">{{ baseGrid.icono }}</v-icon>
                </v-list-tile-action>

                <!-- Nombre -->
                <v-list-tile-content>
                    <v-list-tile-title v-text="baseGrid.nombre" @click="irABase(baseGrid.id)" class="pointer"></v-list-tile-title>
                </v-list-tile-content>

                <!-- Menu -->
                <v-menu offset-y>
                    <!-- Activador -->
                    <v-btn icon slot="activator">
                        <v-icon>keyboard_arrow_down</v-icon>
                    </v-btn>
                    <v-list>
                        <!-- Nombre -->
                        <v-list-tile>
                            <v-text-field
                                    v-model="baseGrid.nombre"
                                    @click.stop @blur="renombrar({id: baseGrid.id, nombre: baseGrid.nombre, base: baseGrid.base})"
                                    @keyup.enter="renombrar({id: baseGrid.id, nombre: baseGrid.nombre, base: baseGrid.base})">
                            </v-text-field>
                        </v-list-tile>

                        <!-- Borrar -->
                        <v-list-tile avatar
                                     @click="borrar({ id: baseGrid.id, base: baseGrid.base, nombre: baseGrid.nombre, grupo: idGrupo })">
                            <v-list-tile-action>
                                <v-icon light>delete</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>Borrar</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-list-tile>
        </v-list>
    </div>
</template>
<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'baseGrid',
    data: function () {
      return {}
    },
    props: ['baseGrid', 'idGrupo'],
    methods: {
      ...mapActions('bases', ['borrarBase', 'renombrarBase']),
      borrar (params) {
        this.borrarBase(params)
      },
      renombrar (params) {
        this.renombrarBase(params)
      },
      irABase(idBase) {
        this.$router.push('/base/' + idBase)
      }
    },
    created() {

    }
  }
</script>